var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"fluid":""}},[_c('div',{staticClass:"dashboard"},[_c('div',{staticClass:"dashboard-content grid-layout"},_vm._l((_vm.links),function(item){return _c('Button',{key:item.key,staticClass:"dashboard-item",attrs:{"icon-left":item.icon,"action":item.action,"lg":"","left":""}},[_c('h2',[_vm._v(_vm._s(item.name()))])])}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }